import React from "react";

import "./modal.scss";

const Modal = ({ isOpen, children }) => {
  if (!isOpen) return null;

  return (
    <div className={`autolombard-modal modal-overlay ${isOpen ? "open" : ""}`}>
      <div className="modal-content d-flex flex-column gap-20" onClick={(e) => e.stopPropagation()}>
        {children}
      </div>
    </div>
  );
};

export default Modal;
